module.exports = __webpack_public_path__ + "img/dink-living-1.8eb8cfe0.jpeg";